export const environment = {
  production: true,
  env: 'production',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  API_URL: 'https://api.homhero.com.au/cleaner',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ONE_SIGNAL_KEY: '0e276bd7-9b8e-4a21-b04a-9f8f14d98bbe',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ONE_SIGNAL_SAFARI_KEY:
    'web.onesignal.auto.4345f3b9-0648-4376-838e-008c1d802430',
};
